"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const snap_ui_1 = require("@teamsnap/snap-ui");
const icons_1 = require("components/common/icons");
const PriceDisplay_1 = __importDefault(require("./PriceDisplay"));
const React = __importStar(require("react"));
const PLAN_HIGHLIGHTED = {
    'TeamSnap Basic': false,
    'TeamSnap Premium': true,
    'TeamSnap Ultra': false,
};
const FEATURES = {
    'TeamSnap Basic': {
        list: [
            {
                text: '30 roster members',
                icon: icons_1.Group,
            },
            {
                text: "<div class='sui-flex sui-flex-col sui-gap-0.5'><div>All core features</div><div style='font-size: 12px'>Scheduling, messaging, availability, alerts & reminders, real-time game sharing, assignments, lineups & stats, and payments</div></div>",
                icon: icons_1.Settings,
            },
        ],
        heading: 'Top Basic features:',
    },
    'TeamSnap Premium': {
        list: [
            { text: '40 roster members', icon: icons_1.Group },
            {
                text: 'Skill-building drills and practice plans (for team owner & managers)',
                icon: icons_1.Tactic,
            },
            {
                text: 'Ad-free experience (for team owner & managers)',
                icon: icons_1.Run,
            },
            {
                text: "<div class='sui-flex sui-flex-col sui-gap-0.5'><div>All core features</div><div style='font-size: 12px'>Scheduling, messaging, availability, alerts & reminders, real-time game sharing, assignments, lineups & stats, and payments</div></div>",
                icon: icons_1.Settings,
            },
        ],
        heading: 'Top Premium features:',
    },
    'TeamSnap Ultra': {
        list: [
            {
                text: "<span style='font-style: italic'>Unlimited</span> roster members",
                icon: icons_1.Group,
            },
            {
                text: 'Skill-building drills and practice plans (for team owner & managers)',
                icon: icons_1.Tactic,
            },
            {
                text: 'Ad-free experience (for team owner & managers)',
                icon: icons_1.Run,
            },
            {
                text: "<div class='sui-flex sui-flex-col sui-gap-0.5'><div>All core features</div><div style='font-size: 12px'>Scheduling, messaging, availability, alerts & reminders, real-time game sharing, assignments, lineups & stats, and payments</div></div>",
                icon: icons_1.Settings,
            },
        ],
        heading: 'Top Ultra features:',
    },
};
const BILLED_PLANS = {
    year: '(billed annually)',
    month: '',
};
const PLAN_TITLES = {
    'TeamSnap Basic': {
        title: 'Basic Plan',
        subtitle: 'The Basics',
        description: 'Track availability, send reminders, and keep everyone in sync.',
    },
    'TeamSnap Premium': {
        title: 'Premium Plan',
        subtitle: 'Team Tools & Training Content',
        description: 'Essential tools for seamless scheduling, communication, and practice planning.',
    },
    'TeamSnap Ultra': {
        title: 'Ultra Plan',
        subtitle: 'Unlimited Access',
        description: 'Unlimited roster spots to grow your team, and all Premium team tools & training content.',
    },
};
const SUBSCRIBE_BUTTON_LABELS = {
    Subscribe: 'Subscribe',
    'Start Trial': 'Try risk free for 7 days',
};
const PlanCard = ({ product, isProcessing, selectedId, onChoosePlan, frequency, onlyTwoOptions, }) => {
    return (React.createElement("article", { className: `plan ${PLAN_HIGHLIGHTED[product.title] ? 'highlighted' : ''} sui-p-4 sui-mb-3 d:sui-mb-1 sui-mx-auto d:sui-mx-0`, key: product.priceId, "data-testid": `plan-${product.dataId}` },
        React.createElement("section", null,
            React.createElement("header", { className: "sui-flex sui-justify-between sui-mb-1 sui-align-left" },
                React.createElement("div", { className: "sui-flex sui-flex-col" },
                    React.createElement("h2", { className: "plan-title sui-text-left sui-mb-0.5" }, PLAN_TITLES[product.title].title),
                    React.createElement("h3", { className: "plan-subtitle sui-text-left sui-mb-0.5", dangerouslySetInnerHTML: {
                            __html: PLAN_TITLES[product.title].subtitle,
                        } }))),
            React.createElement("p", { className: "plan-description sui-mb-3", dangerouslySetInnerHTML: {
                    __html: PLAN_TITLES[product.title].description,
                } }),
            React.createElement("section", { className: "sui-mb-4 d:sui-hidden" },
                React.createElement(snap_ui_1.LabelButton, { "data-testid": "start-trial-button", className: `sui-mb-2 sui-w-full ${onlyTwoOptions ? 'sui-font-size-6' : ''}`, variantType: "secondary", onClick: () => onChoosePlan(product.priceId), labelText: SUBSCRIBE_BUTTON_LABELS[product.ctaLabel], disabled: isProcessing && selectedId !== product.priceId, loading: isProcessing && selectedId === product.priceId }),
                React.createElement(PriceDisplay_1.default, { product: product, frequency: frequency, billedLabel: BILLED_PLANS[frequency], className: 'sui-mt-1' })),
            React.createElement("div", { className: "features-text sui-mb-2 u-textBold" }, FEATURES[product.title].heading),
            React.createElement("section", { className: "features-list d:sui-mb-4" }, FEATURES[product.title]?.list.map((feature, i) => (React.createElement("div", { className: "feature-item", key: `feature-item-${i}` },
                React.createElement("div", { className: "feature-item__icon" },
                    React.createElement(feature.icon, { fill: PLAN_HIGHLIGHTED[product.title] ? '#fff' : '#6A7383' })),
                React.createElement("div", { dangerouslySetInnerHTML: { __html: feature.text } })))))),
        React.createElement("section", { className: "sui-hidden d:sui-block" },
            React.createElement(snap_ui_1.LabelButton, { "data-testid": "start-trial-button", className: `sui-mb-2 sui-w-full ${onlyTwoOptions ? 'sui-font-size-6' : ''}`, variantType: "secondary", onClick: () => onChoosePlan(product.priceId), labelText: SUBSCRIBE_BUTTON_LABELS[product.ctaLabel], disabled: isProcessing && selectedId !== product.priceId, loading: isProcessing && selectedId === product.priceId }),
            React.createElement(PriceDisplay_1.default, { product: product, frequency: frequency, billedLabel: BILLED_PLANS[frequency], className: 'sui-mt-3' }))));
};
exports.default = PlanCard;
